<ng-container *transloco="let t; read: 'loginPage'">
  <aodocs-message-banner *ngIf="isEmailBannerVisible" [message]="emailMessage" [type]="'warning'" (closed)="isEmailBannerVisible = false">
  </aodocs-message-banner>

  <mat-card>
    <img src="assets/icon-128.png" alt="{{ t('AODOCS_LOGO') }}" />
    <h2>{{ t('WELCOME') }}</h2>

    <mat-progress-spinner
      *ngIf="((isPendingAuth | async) || loading) === true || loadingProviders; else loaded"
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>

    <ng-template #loaded>
      <ng-container *ngIf="!showEmailForm; else emailForm">
        <aodocs-select-sign-in-provider
          [providers]="providers"
          (authenticateWith)="startAuthentication($event)"
        ></aodocs-select-sign-in-provider>
      </ng-container>
    </ng-template>
  </mat-card>

  <aodocs-message-banner *ngIf="isErrorBannerVisible" [message]="error" (closed)="isErrorBannerVisible = false"> </aodocs-message-banner>
</ng-container>

<ng-template #emailForm>
  <aodocs-password-form-sign-in
    (clickEvent)="showEmailForm = false"
    (emailSent)="initEmailSentWarning($event)"
  ></aodocs-password-form-sign-in>
</ng-template>
